import { TIME_OF_NIGHT_OPTIONS } from '../TIME_OF_NIGHT_OPTIONS';
import { TimeOfNightOptionIdType } from '../types';

const DEFAULT_ID: TimeOfNightOptionIdType = 'late_night';
const DEFAULT_TITLE = TIME_OF_NIGHT_OPTIONS[1].title; // late_night option

export const getTimeOfNightChoiceIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): TimeOfNightOptionIdType | null => {
  const id = TIME_OF_NIGHT_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT_ID;
  }

  return null;
};

export const getTimeOfNightChoiceTitleById = (
  id: TimeOfNightOptionIdType | null | undefined,
  withDefault = false,
): string | null => {
  const title = TIME_OF_NIGHT_OPTIONS.find((option) => option.id === id)?.title;

  if (title) {
    return title;
  }

  if (withDefault) {
    return DEFAULT_TITLE;
  }

  return null;
};
